import BaseApi from "./BaseApi";

const baseUrl = 'api/Client/';

class ClientService {

    static getClient(document: string): Promise<any> {
        return BaseApi.get(`${baseUrl}${document}`);
    }
    
    public getAllClient(
        name:string|null, 
        document:string|null
    ): Promise<any> {
        return BaseApi.post(`${baseUrl}allClients`,{ name, document });
    }
}

export default ClientService;